/**
 * Canned-response placeholder substitution — Step 21. Client-side only: a
 * canned response is inserted as already-final text, the server never sees
 * a template, only the resolved HTML (same as anything else typed in).
 */
export interface PlaceholderContext {
  ticketRef: string;
  ticketSubject: string;
  requesterName: string;
  agentName: string;
}

const TOKENS: Record<string, (ctx: PlaceholderContext) => string> = {
  'ticket.ref': (c) => c.ticketRef,
  'ticket.subject': (c) => c.ticketSubject,
  'requester.name': (c) => c.requesterName,
  'requester.firstName': (c) => c.requesterName.split(' ')[0] ?? c.requesterName,
  'agent.name': (c) => c.agentName,
};

export function substitutePlaceholders(html: string, ctx: PlaceholderContext): string {
  return html.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (match, token: string) => {
    const resolve = TOKENS[token];
    return resolve ? resolve(ctx) : match;
  });
}
